export enum CategoryDeepLevel {
    Main = 1,
    Secondary = 2,
    Ternary = 3,
}
